import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'components';
import Button from 'components/button';

const SuccessModal = ({ isVisible, setVisible, title, message, returnButtonTitle, returnButtonNavigate }) => {
  const navigate = useNavigate();

  const returnButtonActions = () => {
    setVisible(false)
    navigate(`${returnButtonNavigate}`)
  }

  return (
    <Modal
      open={isVisible}
      // Icon={WarningRed}
      onCancel={() => setVisible(false)}
      footer={returnButtonTitle && [
        <Button
          label={returnButtonTitle}
          type={'default'}
          onClick={returnButtonActions}
        />,
      ]}
      className="success-modal"
      maskClosable={false}
      closable={false}

    >
      {(title && message) && 
        <>
          <div className="succes-modal-title">
            <h2>{title}</h2>
          </div>
          <div className="succes-modal-message">
            {message}
          </div>
        </>
      }
      
    </Modal>
  );
};

export default SuccessModal;
